import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { CustomGatewaySetting } from '../types'

type CustomGatewaySettingsList = {
  items: CustomGatewaySetting[]
  total: number
}

type Payload = CustomGatewaySettingsList & {
  page: number
}

export type FetchCustomGatewaySettingsListAction = FSA<undefined, Payload, string>
type FetchCustomGatewaySettingsList = () => MrxThunk<FetchCustomGatewaySettingsListAction>
type QueryResponse = GraphQLResponse<'customGatewaySettingsListPage', CustomGatewaySettingsList>

const FETCH_CUSTOM_GATEWAY_SETTINGS_LIST = `
  query fetchCustomGatewaySettingsList ($page: Int, $size: Int, $workspaceId: Int!) {
    customGatewaySettingsListPage (page: $page, size: $size, workspaceId: $workspaceId) {
      items {
        id
        name
        shippingCarrier
        carrierCode
        serviceCode
        clientId
        clientSecret
        retailerApiKey
        retailerCompanyRefId
        supplierApiKey
        supplierCompanyRefId
        internalLogin
        internalPassword
      }
      total
    }
  }
`

const fetchCustomGatewaySettingsList: FetchCustomGatewaySettingsList = () => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_CUSTOM_GATEWAY_SETTINGS_LIST,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      },
      customGatewaySettings: {
        pagination: { currentPage: page, size }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_CUSTOM_GATEWAY_SETTINGS_LIST,
      variables: { page, size, workspaceId }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { customGatewaySettingsListPage } = data
    if (!customGatewaySettingsListPage) {
      throw new Error("Can't get Shipstation Settings list page!")
    }

    dispatch({
      type: t.FETCH_CUSTOM_GATEWAY_SETTINGS_LIST,
      payload: {
        page,
        total: customGatewaySettingsListPage.total,
        items: customGatewaySettingsListPage.items
      },
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_CUSTOM_GATEWAY_SETTINGS_LIST,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchCustomGatewaySettingsList }
